<template>
    <v-container fluid>
          <v-card-title>
            <v-icon class="me-2">mdi-label</v-icon>
            Category
          </v-card-title>
          <v-card-subtitle> Manage your categories here. </v-card-subtitle>
          <v-card-actions>
            <v-btn @click="openCategoryDialog" color="primary">
              <v-icon left>mdi-plus</v-icon>
              Add Category
            </v-btn>
          </v-card-actions>
          <v-card-text>
            <!-- Categories List -->
            <v-data-iterator :items="categories" :items-per-page="itemsPerPage" v-model:search="searchCategory" :loading="loading">
              <template v-slot:header="{ page, pageCount, prevPage, nextPage }">
                <h1
                  class="text-h4 font-weight-bold d-flex justify-space-between mb-4 align-center"
                >
                  <v-text-field
                    variant="outlined"
                    v-model="searchCategory"
                    density="compact"
                    label="Search"
                    prepend-inner-icon="mdi-magnify"
                    style="max-width: 300px"
                    clearable
                    hide-details
                    single-line
                  ></v-text-field>

                  <div class="d-flex align-center">
                    <div class="d-inline-flex">
                      <v-btn
                        :disabled="page == 1"
                        class="me-2"
                        icon="mdi-arrow-left"
                        size="small"
                        variant="tonal"
                        @click="prevPage"
                      ></v-btn>

                      <v-btn
                        :disabled="page == pageCount"
                        icon="mdi-arrow-right"
                        size="small"
                        variant="tonal"
                        @click="nextPage"
                      ></v-btn>
                    </div>
                  </div>
                </h1>
              </template>
              
              <template v-slot:default="{ items }">
                <v-row>
                  <v-col
                    v-for="(item, i) in items"
                    :key="i"
                    cols="12"
                    sm="3"
                    xl="3"
                  >
                    <v-card>
                      <v-card-title>{{ item.raw.category }}</v-card-title>
                      <v-card-actions>
                        <v-btn
                          @click="editCategory(item.raw)"
                          color="primary"
                          variant="flat"
                          size="small"
                          prepend-icon="mdi-pencil"
                        >
                          Edit
                        </v-btn>
                        <v-btn
                          @click="deleteCategory(item.raw.category_id)"
                          color="error"
                          variant="flat"
                          size="small"
                          prepend-icon="mdi-delete"
                        >
                          Delete
                        </v-btn>
                        <v-btn
                          @click="openSubcategoryDialog(item.raw)"
                          color="secondary"
                          variant="flat"
                          size="small"
                          prepend-icon="mdi-plus"
                        >
                          Subkategori
                        </v-btn>
                      </v-card-actions>

                      <v-divider></v-divider>
                      <v-expansion-panels>
                        <v-expansion-panel title="Subkategori">
                          <v-expansion-panel-text>
                            <v-table>
                              <tbody>
                                <tr
                                  v-for="(subcategory, subIndex) in item.raw
                                    .subcategories || []"
                                  :key="subIndex"
                                >
                                  <td>{{ subcategory.subcategory }}</td>
                                  <td>
                                    <v-btn
                                      class="mx-1"
                                      size="small"
                                      variant="flat"
                                      color="primary"
                                      prepend-icon="mdi-pencil"
                                      @click="editSubcategory(subcategory)"
                                    >
                                      Edit
                                    </v-btn>
                                    <v-btn
                                      size="small"
                                      color="error"
                                      variant="flat"
                                      prepend-icon="mdi-delete"
                                      @click="deleteSubcategory(subcategory.subcategory_id)"
                                    >
                                      Delete
                                    </v-btn>
                                  </td>

                                </tr>
                              </tbody>
                            </v-table>
                          </v-expansion-panel-text>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-card>
                  </v-col>
                </v-row>
              </template>
            </v-data-iterator>
          </v-card-text>

          <!-- Category Dialog -->
    <v-dialog v-model="categoryDialog" max-width="600px" persistent>
      <v-card>
        <v-toolbar>
        <v-toolbar-title flat><strong>{{ editMode ? "Edit Kategori" : "Tambah Kategori" }}</strong></v-toolbar-title>
          <v-spacer></v-spacer>
              <v-btn icon @click="closeDialog('category')">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
        <v-card-text>
          <v-form @submit.prevent="submitCategory">
            <v-text-field
            variant="outlined"
              v-model="category.category"
              label="Nama Kategori"
              required
            ></v-text-field>
            <v-card-actions class="justify-end">
              <div class="text-center">
                <v-btn
                  prepend-icon="mdi-check-circle"
                  type="submit"
                  variant="flat"
                  color="primary"
                >
                  Save
                </v-btn>
                <v-btn
                  prepend-icon="mdi-close-circle"
                  @click="closeDialog('category')"
                  variant="flat"
                  color="secondary"
                >
                  Cancel
                </v-btn>
              </div>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Subcategory Dialog -->
    <v-dialog v-model="subcategoryDialog" max-width="600px" persistent scrollable>
      <v-card>
        <v-toolbar>
          <v-toolbar-title flat><strong>{{ editMode ? "Edit Subkategori" : "Tambah Subkategori" }}</strong></v-toolbar-title>
          <v-spacer></v-spacer>
              <v-btn icon @click="closeDialog('subcategory')">
                <v-icon>mdi-close</v-icon>
              </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-form @submit.prevent="submitSubcategory">
            <v-text-field
            variant="outlined"
              v-model="subcategory.subcategory"
              label="Nama Subkategori"
              required
            ></v-text-field>
            <!-- Category ID is handled internally, not shown in the UI -->
            <v-card-actions class="justify-end">
              <div class="text-center">
                <v-btn
                  prepend-icon="mdi-check-circle"
                  type="submit"
                  variant="flat"
                  color="primary"
                >
                  Save
                </v-btn>
                <v-btn
                  prepend-icon="mdi-close-circle"
                  @click="closeDialog('subcategory')"
                  variant="flat"
                  color="secondary"
                >
                  Cancel
                </v-btn>
              </div>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Snackbar -->
    <v-snackbar
      v-model="snackbar.visible"
      :timeout="snackbar.timeout"
    >
      {{ snackbar.message }}
      <template v-slot:actions>
        <v-btn color="white" text @click="snackbar.visible = false"
          >Close</v-btn
        >
      </template>
    </v-snackbar>

    <!-- Delete Confirmation Dialog for Subcategory -->
<v-dialog v-model="subcategoryDeleteDialog" max-width="400px">
  <v-card>
    <v-card-title class="headline">Delete Confirmation</v-card-title>
    <v-card-text>Are you sure you want to delete this subcategory?</v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn 
        color="primary" 
        variant="flat" 
        size="small" 
        prepend-icon="mdi-close" 
        @click="subcategoryDeleteDialog = false"
      >
        Cancel
      </v-btn>
      <v-btn 
        color="error" 
        variant="flat" 
        size="small" 
        prepend-icon="mdi-delete" 
        @click="confirmDeleteSubcategory"
      >
        Delete
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

<!-- Delete Confirmation Dialog for Category -->
<v-dialog v-model="categoryDeleteDialog" max-width="400px">
  <v-card>
    <v-card-title class="headline">Delete Confirmation</v-card-title>
    <v-card-text>Are you sure you want to delete this category?</v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn 
        color="primary" 
        variant="flat" 
        size="small" 
        prepend-icon="mdi-close" 
        @click="categoryDeleteDialog = false"
      >
        Cancel
      </v-btn>
      <v-btn 
        color="error" 
        variant="flat" 
        size="small" 
        prepend-icon="mdi-delete" 
        @click="confirmDeleteCategory"
      >
        Delete
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
    </v-container>
</template>

<script>
import { useDisplay } from 'vuetify'

export default{
    data(){
        return{
            categories: [],
            subcategories: [],
            filteredSubcategories: [],
            selectedCategory: '',
            itemsPerPage: 12,
            categoryDialog: false,
            editMode: false,
            deleteDialog: false,
            categoryToDelete: '',
            subcategoryToDelete: '',
            subcategoryDeleteDialog: false,
            categoryDeleteDialog: false,
            selectedFilterCategory: '',
            selectedFilterSubcategory: '',
            loading: true,
            search: '',
            category: {
                category: "",
            },
            subcategoryDialog: false,
            subcategory: {
                subcategory: "",
                category_id: '',
            },
            snackbar: {
                visible: false,
                message: "",
                color: "success",
                timeout: 5000,
            },
        }
    },
    async created() {
    await this.fetchCategories();
    await this.fetchSubcategories();
  },
  setup() {
    const { smAndDown } = useDisplay();
    console.log('Is small screen?', smAndDown.value)
    return {
      isSmallScreen: smAndDown.value,
      
    };
    
  },
  methods: {
    async fetchCategories() {
      try {
        const response = await this.$axios.get("/category", {
          headers: {
            "Authorization": "Bearer " + localStorage.getItem('token'),
          },
        });
        this.categories = response.data.data; // Access nested data
      } catch (error) {
        // this.showSnackbar(
        //   "Error fetching categories: " +
        //     (error.response?.data?.message || "Something went wrong"),
        //   "error"
        // );
      } finally {
            this.loading = false; // End loading
        }
    },
    async fetchSubcategories() {
      try {
        const response = await this.$axios.get("/subcategory", {
          headers: {
            "Authorization": "Bearer " + localStorage.getItem('token'),
          },
        });
        this.subcategories = response.data.data;
      } catch (error) {
        // this.showSnackbar("Error fetching subcategories.", "error");
      } finally {
            this.loading = false; // End loading
        }
    },
    resetCategoryForm() {
      this.category = { category: "" };
    },
    resetSubcategoryForm() {
      this.subcategory = {
        subcategory: "",
        category_id: '',
      };
    },
    closeDialog(dialogType) {
     if (dialogType == 'category') {
        this.resetCategoryForm();
        this.categoryDialog = false;
      } else if (dialogType == 'subcategory') {
        this.resetSubcategoryForm();
        this.subcategoryDialog = false;
      }
    },
    openCategoryDialog() {
      this.editMode = false;
      this.category = { category: "" };
      this.categoryDialog = true;
    },
    openSubcategoryDialog(category) {
      this.editMode = false;
      this.subcategory = {
        subcategory: "",
        category_id: category ? category.category_id : '',
      };
      this.subcategoryDialog = true;
    },
    editCategory(item) {
      this.editMode = true;
      this.category = { ...item };
      this.categoryDialog = true;
    },
    editSubcategory(subcategory) {
      this.editMode = true;
      this.subcategory = {
        subcategory_id: subcategory.subcategory_id,
        subcategory: subcategory.subcategory,
        category_id: subcategory.category_id,
      };
      this.subcategoryDialog = true;
    },
    async deleteSubcategory(subcategoryId){
      this.subcategoryToDelete = subcategoryId
      this.subcategoryDeleteDialog = true
    },
    async confirmDeleteSubcategory() {
      try {
        await this.$axios.delete(`/subcategory/${this.subcategoryToDelete}`, {
          headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') }
        });
        this.subcategoryDeleteDialog = false;
        this.showSnackbar("Delete subcategory successful")
        this.fetchCategories()
        this.fetchSubcategories()
        if (index !== -1) {
          this.subcategories.splice(index, 1);
        }
      } catch (error) {
        console.error("Error deleting message:", error);
      }
    },
    async deleteCategory(categoryId){
      this.categoryToDelete = categoryId
      this.categoryDeleteDialog = true
    },
    async confirmDeleteCategory() {
      try {
        await this.$axios.delete(`/category/${this.categoryToDelete}`, {
          headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') }
        });
        
        this.categoryDeleteDialog = false;
        this.showSnackbar("Delete category successful");
        
        // Fetch categories again if needed
        this.fetchCategories();
        this.fetchSubcategories();

        // Correct the parameter name in findIndex
        const index = this.categories.findIndex(category => category.category_id == this.categoryToDelete);
        if (index !== -1) {
          this.categories.splice(index, 1); // Remove the category from the list
        }

      } catch (error) {
        console.error("Error deleting category:", error);
      }
    },
    async submitCategory() {
      try {
        const url = this.editMode ? `/category/${this.category.category_id}` : "/category";
        const method = this.editMode ? "put" : "post";

        await this.$axios({
          method,
          url,
          data: this.category,
          headers: {
            "Authorization": "Bearer " + localStorage.getItem('token'),
          },
        });

        this.showSnackbar(
          this.editMode
            ? "Category updated successfully."
            : "Category created successfully."
        );
        await this.fetchCategories(); // Refresh category list
      } catch (error) {
        this.showSnackbar(
          "Error saving category: " +
            (error.response?.data?.message || "Something went wrong"),
          "error"
        );
      } finally {
        this.closeDialog('category');
      }
    },
    async submitSubcategory() {
      try {
        const url = this.editMode
          ? `/subcategory/${this.subcategory.subcategory_id}`
          : "/subcategory";
        const method = this.editMode ? "put" : "post";

        await this.$axios({
          method,
          url,
          data: this.subcategory,
          headers: {
            "Authorization": "Bearer " + localStorage.getItem('token'),
          },
        });

        this.showSnackbar(
          this.editMode
            ? "Subcategory updated successfully."
            : "Subcategory created successfully."
        );
        await this.fetchCategories(); 
        await this.fetchSubcategories(); // Refresh subcategory list
      } catch (error) {
        this.showSnackbar(
          "Error saving subcategory: " +
            (error.response?.data?.message || "Something went wrong"),
          "error"
        );
      } finally {
        this.closeDialog('subcategory');
      }
    },
    showSnackbar(message, timeout = 3000) {
      this.snackbar.message = message;
      this.snackbar.timeout = timeout;
      this.snackbar.visible = true;
    },
  }
}
</script>

<style scoped>
.mx-auto {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh; /* Adjust as needed */
}

.v-dialog__content--active {
  display: flex;
  align-items: center;
  justify-content: center;
}

.v-dialog--fullscreen .v-card {
  height: 100%;
}

.expand-text {
  white-space: normal; /* Allows text to wrap */
  overflow: visible;  /* Ensures overflow is visible */
}
</style>
